import { InjectionToken } from '@angular/core';
import { StatscoreVizuConfig } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const STATSCORE_VIZU_CONFIG: InjectionToken<StatscoreVizuConfig> = new InjectionToken<StatscoreVizuConfig>(
  'StatscoreVizuConfig'
);
